import Keycloak from 'keycloak-js';

import { isProd } from './config';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = Keycloak({
    url: isProd ? 'https://login.apgsga.ch/auth/' : 'https://login-t1.apgsga.ch/auth/',
    realm: 'apg',
    clientId: 'e-commerce',
});

if (!process.env.REACT_APP_MODE || process.env.REACT_APP_MODE !== 'django') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (window as any).keycloak = keycloak;
}

export default keycloak;
